import './BlankSlate.scss'
import React from 'react'
import Button from './Button'
import classnames from 'classnames'

const BlankSlate = ({ title, body, img, action, children, onAction, className }) => {
  return (
    <div className={classnames('BlankSlate', className)}>
      <img className='BlankSlate_img' src={img} role='presentation' />
      <h1 className='BlankSlate_title'>{title}</h1>
      {body && (
        <p className='BlankSlate_body'>{body}</p>
      )}
      {children}
      {action && onAction && (
        <Button
          className='BlankSlate_action'
          onClick={onAction}
          large>
          {action}
        </Button>
      )}
    </div>
  )
}

BlankSlate.displayName = 'BlankSlate'

export default BlankSlate



// WEBPACK FOOTER //
// ./src/lib/BlankSlate.js